import { Button, Tooltip } from '@mui/material';
import React from 'react';

/**
 * This function represents a submit button.
 * @returns React.Component
 */
export default function SubmitButton({ disabled, title, onClick, children, color = 'primary' }) {
  return (
    <Tooltip title={title ? title : ''}>
      <span>
        <Button onClick={onClick} disabled={disabled} fullWidth={true} variant="contained" type="submit" color={color}>
          {children ? children : 'Opslaan'}
        </Button>
      </span>
    </Tooltip>
  );
}
